<div class="discussion-header">
  @if (comment) {
    <div style="position: relative; display: flex; padding-right: 8px;">
      @if (isShowDiscussionIcon) {
        <mat-icon #discussionIconAvatar class="discussionIcon"
          insTooltip [delayMs]="700" [cfg]="{text: userName, position: {H: 'hLeft', V:'vTop'}, type: 'info'}">
          <div class="acronyms">{{acronymsUserName}}</div>
        </mat-icon>
      }
    </div>
  }

  <div class="showTextArea">
    <div>
      <div style="display: flex">
        <textarea autofocus id="input" #input class="input" placeholder="{{placeholder}}" [(ngModel)]="newCommentText" [rows]="numberOfLines" (click)="clickTextArea()"></textarea>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <div>
          <div class="lowerSection itemControllers alignCenter" style="display: flex; justify-content: flex-end;">
            @if (comment) {
              <div class="textButtonOnPanel" (click)="cancel($event)" [class.disabled]="!newCommentText || newCommentText === ''">Cancel</div>
            }
            @if (comment) {
              <div class="buttonSeperator fontHeight disabledText" [class.disabled]="!newCommentText || newCommentText === ''"> </div>
            }
            <div class="textButtonOnPanel disabledText" style="padding: 0 8px 0 0 ;" (click)="createNewComment()" [class.disabled]="!newCommentText || newCommentText === ''">Add</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
